module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Contents")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1em",
      "line-height": "1.5",
      "text-indent": "1.5em"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_vm._v("\n\t\tPART ONE: The Job")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t1. Putting it in the Newspaper")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t2. Never Too Young, Never Too Old")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t3. Love Kills")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t4. The Twilight Zone")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t5. Better than Real Life")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("\n\t\tSIDEBAR: Romance")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_vm._v("\n\t\tPART TWO: The City")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t6. Home, Sweet Home")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t7. Miami, Old and New")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t8. Christmas in Miami")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t9. Best Freinds")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("\n\t\tSIDEBAR: Duck")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_vm._v("\n\t\tPART THREE: The Heroes")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t10. Fire!")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t11. Water")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t12. Street Cops")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t13. Shot Cops")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t14. Heroes")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("\n\t\tSIDEBAR: No Hero")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_vm._v("\n\t\tPART FOUR: The Storeis")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t15. Lorri")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t16. Lawyers and Judges")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t17. Mrs. Z")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t18. Amy")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t19. Courage")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_vm._v("\n\t\t20. A New Chapter")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_vm._v("\n\t\tAcknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("\n\t\tAbout the Author")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b470c2ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/0425138240_08_toc.vue
// module id = 66
// module chunks = 0